// extracted by mini-css-extract-plugin
module.exports = {"notification":"gu49SQRGZNcyZ7KrX6Jv5"};